import { Injectable } from '@angular/core';
import {
  CanDeactivate
} from '@angular/router';

@Injectable()
export class UnsavedGuard implements CanDeactivate<any> {
  canDeactivate(component: any): boolean {

    if (component.hasUnsavedData()) {
      if (confirm("You have unsaved changes! If you leave, your changes will be lost.")) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }
}



// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/core/unsaved.guard.ts